import { Visibility } from "@mui/icons-material";
import BlockIcon from "@mui/icons-material/Block";
import { TableRow, TableCell, Box } from "@mui/material";
import theme from "../../config/theme/theme";
import { Cadet } from "../../shared/types/scoreboard.types";
import React, { useEffect, useState } from "react";

interface ScoreboardRowProps {
  cadet: Cadet;
  index: number;
  onRowClick: (cadet: Cadet) => void;
}

export const ScoreboardRow: React.FC<ScoreboardRowProps> = ({ cadet, index, onRowClick }) => {
  const handleRowClick = () => {
    onRowClick(cadet);
  };
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);
  const isDisqualified = cadet.isDisqualified;
  const [backgroundColor, setBackgroundColor] = useState<string | undefined>(undefined);
  const [hoverColor, setHoverColor] = useState<string | undefined>(undefined);

  useEffect(() => {
    setBackgroundColor(determineBackgroundColor());
    setHoverColor(determineHoverColor());
  }, [cadet, isDisqualified]);

  const determineBackgroundColor = () => {
    if (isDisqualified) {
      return "#ffabab";
    }
    // // console.log("Cadet:", cadet);
    return cadet.rank <= 10 ? "#7cf28f!important" : undefined;
  };

  const determineHoverColor = () => {
    if (isDisqualified) {
      return "#ffcccc!important";
    }
    return cadet.rank <= 10 ? "#b8ffc3!important" : `${theme.palette.action.hover}!important`;
  };

  return (
    <TableRow
      key={`${cadet.rank}-${cadet.smd}`}
      hover
      onClick={() => handleRowClick()}
      onMouseEnter={() => setHoveredRow(index)}
      onMouseLeave={() => setHoveredRow(null)}
      sx={{
        cursor: "pointer",
        // Highlight top 10 rows
        backgroundColor: backgroundColor,
        "& .MuiTableCell-root": {
          // Make text bold for top 10
          fontWeight: cadet.rank <= 10 ? "bold" : undefined,
        },
        "&:hover": {
          backgroundColor: hoverColor,
        },
      }}
    >
      <TableCell>
        {isDisqualified && <BlockIcon sx={{ color: "red" }} />}
        </TableCell>
      <TableCell>
        {cadet.rank !== 999 && (
          <Box
            component="span"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            {cadet.rank === 1 && "🥇"}
            {cadet.rank === 2 && "🥈"}
            {cadet.rank === 3 && "🥉"}
            {cadet.rank}
          </Box>
        )}
      </TableCell>
      <TableCell>{cadet.primaryCadet}</TableCell>
      <TableCell>{cadet.spousePartner}</TableCell>
      <TableCell>{cadet.smd}</TableCell>
      <TableCell>{cadet.qualification.toFixed(2)}</TableCell>
      <TableCell>{cadet.c1.total.toFixed(2)}</TableCell>
      <TableCell>{cadet.c2.total.toFixed(2)}</TableCell>
      <TableCell>{cadet.c3.total.toFixed(2)}</TableCell>
      <TableCell>{cadet.c4.total.toFixed(2)}</TableCell>
      <TableCell>{cadet.c5.total.toFixed(2)}</TableCell>
      <TableCell sx={{ fontWeight: "bold" }}>{cadet.total.toFixed(2)}</TableCell>
      <TableCell>
        <Visibility
          sx={{
            opacity: hoveredRow === index ? 1 : 0,
            transition: "opacity 0.2s",
            color: theme.palette.primary.main,
          }}
        />
      </TableCell>
    </TableRow>
  );
};
